import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'initials'
})
export class InitialsPipe implements PipeTransform {
    transform(value: string) {
        const splittedName = value.split(' ');
        
        if (splittedName.length === 1) {
            return splittedName[0][0];
        }

        return `${splittedName[0][0]}${splittedName[splittedName.length - 1][0]}`.toUpperCase();
    }
}